import type { OptionType } from '@chartforge/shared-types';
import type { ComponentType } from 'react';
import type { ControlProps } from './types';
import { AxisControl } from './AxisControl';
import { BooleanControl } from './BooleanControl';
import { ColorControl } from './ColorControl';
import { EnumControl } from './EnumControl';
import { FontControl } from './FontControl';
import { LabelControl } from './LabelControl';
import { NumberControl } from './NumberControl';
import { SpacingControl } from './SpacingControl';
import { TextControl } from './TextControl';

/**
 * The single OptionType → control mapping. This is the extension point for
 * the UI kit: ordinary options never need a new React component, and a
 * genuinely new option TYPE is added here once, for all charts and shells.
 */
export const controlRegistry: Record<OptionType, ComponentType<ControlProps>> = {
  color: ColorControl,
  font: FontControl,
  number: NumberControl,
  boolean: BooleanControl,
  enum: EnumControl,
  axis: AxisControl,
  spacing: SpacingControl,
  label: LabelControl,
  layout: NumberControl,
  data: TextControl
};

export function controlForOptionType(type: OptionType): ComponentType<ControlProps> {
  return controlRegistry[type] ?? TextControl;
}

export type { ControlProps };
